import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AppContainer from './App_container';
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from 'react-redux';
import rootReducer from './redux/reducers/root_reducer';
import thunk from "redux-thunk";

const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk]
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppContainer />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
